import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { TextStyle } from 'data/FontStyle';
import useWindowsDimension from 'functions/useWindowsDimension';
import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import { ICompanyProductViewModel } from 'Interfaces/ICompanyProductConfig';
import React, { useEffect, useState } from 'react';
import { CompanyProductList } from '../../../pages/Companies/CompanyProductList';
import EditCompanyProductForm from '../Forms/EditCompanyProductForm';

type EditCompanyProductDrawerProps = {
  buttonIcon: React.ReactNode | null; // or 'any' if you prefer
  buttonContext: string; // or 'any', but string is typically used
  companyProduct?: ICompanyProductViewModel; // Optional prop for company product
};

export const EditCompanyProductDrawer = ({
  buttonIcon,
  buttonContext,
  companyProduct,
}: EditCompanyProductDrawerProps) => {
  const { width } = useWindowsDimension();
  const [open, setOpen] = useState(false);
  let buttonWidth = buttonIcon === null ? '100%' : 32;
  let buttonHeight = buttonIcon === null ? 64 : 32;
  if (!companyProduct) return null;

  // HANDLES
  const handleSave = (editedCompanyProduct: ICompanyProductViewModel) => {
    console.log('Saving edited company product:', editedCompanyProduct);
  };
  return (
    <>
      {buttonIcon === null ? (
        <Button
          variant='contained'
          sx={{
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            width: buttonWidth || '100%',
            height: buttonHeight || '100%',
          }}
          onClick={() => setOpen(!open)}
        >
          <Typography
            sx={{
              textTransform: 'uppercase',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: 2,
              color: 'primary.text',
            }}
          >
            {buttonContext}
          </Typography>
        </Button>
      ) : (
        <Box
          sx={[
            TextStyle.buttonBox,
            {
              width: buttonWidth || 32,
              height: buttonHeight || 32,
            },
          ]}
        >
          <IconButton
            sx={{
              p: 0,
              m: 0,
              width: buttonWidth || 18,
              height: buttonHeight || 18,
            }}
            onClick={() => setOpen(!open)}
          >
            {buttonIcon}
          </IconButton>
        </Box>
      )}
      <Drawer anchor={'left'} open={open} onClose={() => setOpen(!open)}>
        <Box sx={{ width: width / 2, backgroundColor: 'primary.main' }}>
          <EditCompanyProductForm
            companyProduct={companyProduct}
            handleSave={() => handleSave(companyProduct)}
          />
        </Box>
      </Drawer>
    </>
  );
};
